/**
 * The boundary markers that bracket one AIA turn on the designer's undo stack.
 *
 * They live here rather than in the assistant frontend because they are a
 * contract between the assistant and anything that writes to the canvas on the
 * user's behalf — including the deterministic visual-edits apply, which needs to
 * bracket its own write without pulling the chat UI in behind two action
 * creators (EXT-2020).
 *
 * Neither marker changes app state. `UndoRedoUtils` turns each into a no-op
 * entry on the `designer` stack, and the pair's scope is what lets the chat undo
 * or redo a whole turn at once.
 */
import {ActionCreator, createAction} from '@packages/utilities/create-action';

export const AI_ASSISTANT_TURN_START = 'AI_ASSISTANT_TURN_START';
export const AI_ASSISTANT_TURN_END = 'AI_ASSISTANT_TURN_END';

export type AiAssistantTurnMarkerPayload = {
  /**
   * The ID of the user message that initiated the turn. Lets the AIA UI map a
   * chat message back to its boundary markers in the undo/redo stack.
   */
  turnId: string;
};

export const aiAssistantTurnStart: ActionCreator<
  typeof AI_ASSISTANT_TURN_START,
  AiAssistantTurnMarkerPayload
> = createAction(AI_ASSISTANT_TURN_START);

export const aiAssistantTurnEnd: ActionCreator<
  typeof AI_ASSISTANT_TURN_END,
  AiAssistantTurnMarkerPayload
> = createAction(AI_ASSISTANT_TURN_END);
